import { YOO_FINDS_CDN } from "@/common";

export const SALON_BANNER = `${YOO_FINDS_CDN}/pc/creators-salon/salon-banner-v2.webp`;
export const SALON_ABOUT_US = `${YOO_FINDS_CDN}/pc/creators-salon/salon-about-us.webp`;
export const SALON_PAST_EVENT = `${YOO_FINDS_CDN}/pc/creators-salon/salon-past-event.webp`;
export const SALON_LOGO_GROUP = `${YOO_FINDS_CDN}/pc/creators-salon/salon-logo-group.webp`;
export const SALON_CREATORS_GROUP = `${YOO_FINDS_CDN}/pc/creators-salon/salon-creators-group.webp`;
export const BRAND_HISTORY_VIDEO = `${YOO_FINDS_CDN}/shop-pc/home/brand-history/brand-history-video.mp4`;
